module.exports = __webpack_public_path__ + "static/climateChange-df0b6a6e8a29b22eca2d3a0713711314.png";